// extracted by mini-css-extract-plugin
export var form = "_40-0";